import { useLayoutEffect } from 'react'
import useStore from '@src/store/common/global'

/**
 * 把 store.containerWidth 同步到 body 类名（body.cw-medium / body.cw-spacious）。
 * compact 是默认值，不加任何类名（保持 .layout-content 的原始样式）。
 * 必须在 <BrowserRouter> 外侧调用，确保路由切换之间类名也持续存在。
 */
export const useContainerWidthSync = () => {
	const width = useStore((s) => s.containerWidth)
	useLayoutEffect(() => {
		const cls = document.body.classList
		// 先清掉所有旧的 cw-* 类
		for (let i = cls.length - 1; i >= 0; i--) {
			if (cls[i].startsWith('cw-')) cls.remove(cls[i])
		}
		// compact 是默认，不加类
		if (width !== 'compact') {
			cls.add(`cw-${width}`)
		}
	}, [width])
}
